var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarStoryIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#08B758"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 5H8C7.15 5 6.5 5.65 6.5 6.5V14.5C6.5 14.6 6.5 14.65 6.55 14.75C6.7 15 7 15.05 7.25 14.95L10 13.35L12.75 14.95C12.85 15 12.9 15 13 15C13.3 15 13.5 14.8 13.5 14.5V6.5C13.5 5.65 12.85 5 12 5Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarStoryIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_story_icon.f238e217d5056753a93e845d6b47f1e1.svg";